/******************************************************************
 * ##: Location tracking constants
 * Centralized configuration for offline GPS location collection tied to boat services.
 * Keep every tunable value here instead of scattering magic numbers across the code.
 *
 * TL;DR: Thresholds, timeouts and action types for GPS tracking.
 * History:
 * 23-07-2026: Created
 ******************************************************************/

// Persist a new automatic position once the boat has moved at least this distance.
export const LOCATION_DISTANCE_THRESHOLD_METERS = 20;

// Persist a position at least this often while stationary (or moving less than the distance threshold).
export const LOCATION_STATIONARY_INTERVAL_MS = 60_000;

// watchPosition/getCurrentPosition: accept a cached fix up to this age.
export const LOCATION_MAXIMUM_AGE_MS = 5_000;

// watchPosition/getCurrentPosition: give up waiting for a fix after this long.
export const LOCATION_TIMEOUT_MS = 20_000;

// captureActionLocation: reuse the last known fix if it is fresher than this; otherwise request a new one.
export const LOCATION_ACTION_FRESHNESS_MS = 10_000;

// Maximum number of location records pushed per sync batch.
export const LOCATION_SYNC_BATCH_SIZE = 200;

/**
 * Action types that trigger an immediate location capture.
 * Add new entries here (and call captureActionLocation at the confirm point) to make
 * future actions store a location without touching the tracker or the sync flow.
 */
export const LOCATION_ACTIONS = {
  SERVICE_START: "service_start",
  SERVICE_END: "service_end",
  FUEL_REFUEL: "fuel_refuel",
  CRATE_COUNT: "crate_count",
  BEVERAGE_TRANSFER: "beverage_transfer",
  CONSUMPTION_SALE: "consumption_sale",
};

/**
 * GPS status values surfaced to the discrete UI indicator.
 * These are internal identifiers; user-facing labels are resolved in the component.
 */
export const LOCATION_STATUS = {
  IDLE: "idle",
  ACTIVE: "active",
  WAITING: "waiting",
  UNAVAILABLE: "unavailable",
  DENIED: "denied",
};
